import { Box } from "@mui/material"
import { useSelector } from "react-redux"
import { AppState } from "../../core/app/AppReducer"
import BossAutocomplete from "./BossAutocomplete"
import { LocationQueryAutocomplete, useQueryLocationAutocomplete } from "./LocationAutocomplete"

const DungeonTracker = () => {

    let { data: locations } = useQueryLocationAutocomplete()

    let isDungeonShuffle = useSelector((state: AppState) => state.ui.ootr.main.isDungeonShuffle)
    let isBossShuffle = useSelector((state: AppState) => state.ui.ootr.main.isBossShuffle)

    if (!isBossShuffle && !isDungeonShuffle)
        return null;

    let dungeons = locations.filter(x => x.locationType?.id === 2);

    return <Box display="flex">
        <table>
            <thead>

                <tr>
                    <td>In the dungeon</td>
                    {isDungeonShuffle && <td width={250}>You can find</td>}
                    {isBossShuffle && <td>the boss is</td>}
                    {/* <td>Major Item Found</td> */}
                </tr>
            </thead>
            <tbody>
                {dungeons.map(d => {
                    return <tr key={d.name}>
                        <td>{d.name}</td>
                        {isDungeonShuffle && <td><LocationQueryAutocomplete locationTypeId={2} label="Location" /></td>}
                        {isBossShuffle && <td><BossAutocomplete /></td>}
                        {/* <td>
                            <Box display="flex" flexDirection="row">
                                <OotItemContextMenuButton />
                                <OotItemContextMenuButton />
                                <OotItemContextMenuButton /></Box></td>*/}
                    </tr>
                })}
            </tbody>
        </table>
    </Box>

}

export default DungeonTracker